const MINUTES_IN_HOUR = 60;
const MINUTES_IN_DAY = 1440;
const MS_PER_MINUTE = 60000;

function normalizeTimeAgo(baseValue, divisor, suffix) {
  return `${Math.round(baseValue / divisor)}${suffix}`
}

function getAbsoluteDifferenceInMinutes(value) {
  const parsedValue = new Date(value);
  if (Number.isNaN(parsedValue.getTime())) {
    throw new Error('Invalid date value');
  }

  return Math.abs(Math.round((parsedValue.getTime() - Date.now()) / MS_PER_MINUTE));
}

export default {
  install: (Vue) => {
    Vue.filter("asOfDateAgo", (value) => {
      if (!value) {return ''; }

      try {
        const diffMinutes = getAbsoluteDifferenceInMinutes(value);

        if (diffMinutes >= MINUTES_IN_DAY) {
          return normalizeTimeAgo(diffMinutes, MINUTES_IN_DAY, 'd');
        } else if (diffMinutes >= MINUTES_IN_HOUR) {
          return normalizeTimeAgo(diffMinutes, MINUTES_IN_HOUR, 'h');
        } else if (diffMinutes < MINUTES_IN_HOUR && diffMinutes > 0) {
          return `${Math.ceil(diffMinutes)}m`;
        } else if (diffMinutes === 0) {
          return 'Now';
        }
      } catch (err) {
        console.error('Failed to render asOfDateAgo filter', err);
        return '';
      }
    });
  }
};
